
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

class TermsService {
  static async getTermsStatus() {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${API_BASE_URL}/terms/status`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting terms status:', error);
      throw error;
    }
  }

  static async acceptTerms(termsVersion = null) {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      // Use provided version or get from environment
      const version = termsVersion || process.env.REACT_APP_TERMS_VERSION || '1.0';

      const response = await fetch(`${API_BASE_URL}/terms/accept`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ termsVersion: version }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error accepting terms:', error);
      throw error;
    }
  }

  static async checkIfUserNeedsToAcceptTerms() {
    try {
      const status = await this.getTermsStatus();
      console.log(process.env.REACT_APP_TERMS_VERSION,'process.env.REACT_APP_TERMS_VERSION');
      const currentVersion = process.env.REACT_APP_TERMS_VERSION || '1.0'; // Get version from env
      
      // User needs to accept if:
      // 1. They haven't accepted terms at all
      // 2. They accepted an older version of terms
      return !status.data.termsAccepted || 
             status.data.termsVersion !== currentVersion;
    } catch (error) {
      // If there's an error (like user not authenticated), assume they don't need to accept
      return false;
    }
  }
}

export default TermsService; 